import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

import './component.scss'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './images/arrow_up.svg'
import './images/arrow_down.svg'

const app = Application.start()

app.register(
  'advanced-client-search-pc',
  class extends Controller {
    static targets = [
      'prefectureSelect',
      'citySelect',
      'partTypeRadio',
      'sortSelect',
      'searchButton',
      'form'
    ]


    connect() {
      this.initializeCitySelects()
    }

    async fetchCitiesData(prefectureName, partTypeUrl) {
      const response = await fetch(`/api/prefecture/${prefectureName}/enable_cities_for_part_type/?part_type_url=${partTypeUrl}`)
      const cities = await response.json()
      return cities
    }

    resetCity() {
      const citySelect = this.citySelectTarget
      citySelect.value = ''
      citySelect.innerHTML = ''
      const defaultOption = document.createElement('option')
      defaultOption.value = ''
      defaultOption.text = '-市区町村'
      citySelect.appendChild(defaultOption)
    }

    async updateCitySelect(selectedCityId = 0) {
      const prefectureName = this.prefectureSelectTarget.value
      const partTypeUrl = this.getSelectedPartType()

      if (!prefectureName || !partTypeUrl) return

      const cities = await this.fetchCitiesData(prefectureName, partTypeUrl)

      this.resetCity()
      cities.forEach(city => {
        const option = document.createElement('option')
        option.value = city.id
        option.text = city.name
        option.disabled = !city.enabled
        option.selected = city.id == selectedCityId

        this.citySelectTarget.appendChild(option)
      })
    }

    getSelectedPartType() {
      const checkedRadio = this.partTypeRadioTargets.find(radio => radio.checked)
      return checkedRadio ? checkedRadio.value : null
    }


    getCheckedRadioValue(name) {
      const radio = this.element.querySelector(`input[name="${name}"]:checked`)
      return radio ? radio.value : null
    }

    // URLエンコーディング関数
    encodeURIComponentSafe(str) {
      return encodeURIComponent(String(str || ''))
    }

    // Stimulus action: 都道府県・工事箇所変更時
    async handleInputChange(event) {
      const prefectureName = this.prefectureSelectTarget.value

      this.resetCity()

      if (!prefectureName) return
      await this.updateCitySelect()
    }

    // Stimulus action: 検索ボタンクリック時
    performSearch() {
      const prefectureName = this.prefectureSelectTarget.value
      const cityId = this.citySelectTarget.value
      const partTypeUrl = this.getSelectedPartType()
      const sortURL = this.sortSelectTarget.value


      // 現在のpathに /ranking が含まれているかチェック
      const isRankingPage = window.location.pathname.includes('/ranking')

      let url

      if (!prefectureName) {
        url = `/part/${this.encodeURIComponentSafe(partTypeUrl)}`
      } else {
        url = `/area/${this.encodeURIComponentSafe(prefectureName)}`
        if (cityId) {
          url += `/${this.encodeURIComponentSafe(cityId)}`
        } else {
          url += '/part'
        }
        url += `/${this.encodeURIComponentSafe(partTypeUrl)}`

        // ランキングページから来た場合は /ranking を追加
        if (isRankingPage) {
          url += '/ranking'
        }
      }

      // URLパラメータを構築
      const params = new URLSearchParams()

      if (sortURL && !isRankingPage) {
        params.append('order', sortURL)
      }


      if (params.toString()) {
        url += `?${params.toString()}`
      }

      window.location.href = url
    }


    // 初期化時の市区町村セレクトボックス更新処理
    async initializeCitySelects() {
      const prefectureName = this.prefectureSelectTarget.value
      if (!prefectureName) return

      const currentCityId = this.citySelectTarget.value
      await this.updateCitySelect(currentCityId)
    }

  }
)
